
import { useSelector } from "react-redux";
import useGlobal from "../../../util/Global";
import { useEffect, useState } from "react";
import AdayBasvurularservice from "../../../service/Ebasvuru/AdayBasvurularService";

const BasvuruStatus = () => {

    const { t } = useGlobal();

    const user = useSelector(user => user.auth);

    const applicationInfo = {
        companyLogo: "/sc-ua-logo-mobile.svg",
        companyName: "Securitas",
        takipLabel: "Başvuru Takip Numaranız",
        messages: [
            "Değerli Adayımız,",
            "Başvurunuz için teşekkür ederiz.",
            "Başvurularım sayfasında başvuru durumunuzu takip edebilirsiniz.",
            "Securitas Güvenlik Hizmetleri A.Ş.",
        ],
    };

    const [basvurForm, setBasvurForm] = useState(false);

    useEffect(() => {
        let isMounted = true; // Track component mount status
        AdayBasvurularservice.fullGet({
            filter: {
                adayId: user?.user?.userId,
                iapId: user?.iapId
            }
        }).then((res) => {

            if (isMounted && res?.resultObject) {
                setBasvurForm(res?.resultObject[0]);
            }
        });

        return () => {
            isMounted = false; // Cleanup: Prevent state update after unmount
        };
    }, []);

    return (
        <div className="column is-full" style={{ color: "#0a042d", paddingTop: 90, alignContent: "center", minHeight: '70vh' }}>
            <div style={{ textAlign: "center" }}>
                <img
                    src={applicationInfo.companyLogo}
                    style={{ width: "200px" }}
                    alt={applicationInfo.companyName}
                />
                {applicationInfo.messages.map((message, index) => (
                    <div key={index} style={{ marginTop: "5px" }}>
                        <span>{message}</span>
                    </div>
                ))}
                <div style={{ marginTop: "5px" }}>
                    <span style={{ fontSize: "30px", marginTop: "15px" }}>
                        <i className="fa-regular fa-circle-down"></i>
                    </span>
                </div>
                <div style={{ marginTop: "5px" }}>
                    <span style={{ fontWeight: "bold", marginTop: "15px", fontSize: '1rem' }}>
                        {applicationInfo.takipLabel}: {basvurForm.basvuruTakipNo}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BasvuruStatus;